// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQs-module--root--12cG4","cta":"FAQs-module--cta--1xAvY"};